// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"3aab1c28","977":"fb0994ea"}[chunkId] + ".chunk.js";
};